<template>
  <v-container
    class="pa-0 mt-md-2 max-width-sm"
  >
    <v-card
      flat
      tile
      class="pa-3"
    >
      <v-toolbar
        flat
      >
        <v-btn
          icon
          to="/eleave/SickLeaveList"
        >
          <v-icon>{{ mdiArrowLeft }}</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ $t('eleave.SickForm') }}
        </v-toolbar-title>
      </v-toolbar>

      <div>
        <div class="float-right">
          <s-class-pdf
            :url="pdfPath"
          />
        </div>
        <v-tooltip
          v-if="$config.isBrowser && currCert.id"
          color="black"
          top
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              @click="downloadSignedForm"
            >
              <v-icon>{{ mdiFileDownloadOutline }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('eleave.SickForm.downloadSignedForm') }}</span>
        </v-tooltip>
      </div>

      {{ $t('eleave.PatientName') }}：<span class="underline">{{ currCert.patientName }}</span><br>
      {{ $t('eleave.SickStartDate') }}：<span class="underline">{{ formatDate(currCert.startSickDate) }}</span>
      <span class="ml-3">{{ $t('eleave.SickEndDate') }}：</span><span class="underline">{{ formatDate(currCert.leaveToDate) }}</span>
      <br><br>
      {{ $t('eleave.DoctorStatement') }}：
      <p v-if="currCert.isStayAtHome">
        {{ $t('eleave.StayAtHome') }}
      </p>
      <p v-if="currCert.isStayAtHospital">
        {{ $t('eleave.StayInHospital') }}
      </p>
      <p v-if="currCert.isNeedAccompaniment">
        {{ $t('eleave.StayWith', [currCert.accompanyingPersonRelationAndName]) }}
      </p>
      <p v-if="currCert.isNoNeedToStayAtHome">
        {{ $t('eleave.DontNeedStayInHome') }}
      </p>
      <p v-if="currCert.isNeedTreatment">
        {{ $t('eleave.NeedTreatment') }}
      </p>
      <p v-if="currCert.isRehabilitationAfterTreatment">
        {{ $t('eleave.AfterHospital', [currCert.rehabilitationDaysAfterTreatment]) }}
      </p>

      <br>
      {{ currCert.doctorName }} {{ currCert.doctorSsmId }}

      <br><br><br>

      <template v-if="currCert.isNoNeedToStayAtHome">
        <h3 class="subtitle">
          {{ $t('eleave.Statement') }}
        </h3>

        <div>
          {{ $t('eleave.PersonalStatement') }}

          <v-text-field
            v-model="form.claimCanbeFoundDay"
            hide-details
            class="d-block d-md-inline-block mr-4"
            style="min-width: 350px;"
            :suffix="$t('eleave.Sick.Days')"
          />
          <v-text-field
            v-model="form.claimCanbeFoundHour"
            hide-details
            class="d-block d-md-inline-block mr-4"
            :suffix="$t('eleave.Sick.Hours')"
          />
          <v-text-field
            v-model="form.claimCanbeFoundMinute"
            hide-details
            class="d-block d-md-inline-block mr-4"
            :suffix="$t('eleave.Sick.Mins')"
          />
          <span class="d-inline-block pt-4">
            {{ $t('eleave.CanFindMeHere') }}
          </span>
          <v-text-field
            v-model="form.claimCanbeFoundLocation"
            hide-details
            class="d-block mr-4"
          />
        </div>

        <br><br>
      </template>
      <h3
        v-show="false"
        class="subtitle"
      >
        {{ $t('Training.SubmitTarget') }}
      </h3>
      <v-row v-if="!currCert.id">
        <v-col
          cols="12"
          md="6"
          class="d-flex"
        >
          <s-search-staff-muti
            v-model="searchStaffCode"
            show-group
            :label="$t('Training.SubmitTarget')"
            style="overflow: hidden;"
            @dataChange="form.staffList = $event "
          />

          <!--
          <v-btn
            class="mt-2 ml-2"
            @click="addStaffToNotice"
          >
            {{ $t('PublicServant.Action.New') }}
          </v-btn>
          -->
        </v-col>
      </v-row>

      <div
        v-if="currCert.id"
      >
        <s-notice-dialog
          :cert="form"
        />
        <v-subheader
          v-show="false"
          class="ml-n4"
        >
          {{ $t('eleave.Sick.noticeBelowStaff') }}
        </v-subheader>
        <div
          v-for="(paramReceiverInfo, index) in form.paramNotifyInfos"
          v-show="false"
          :key="index"
        >
          <div class="d-inline-block mb-3 px-3 py-2 grey lighten-4 text--primary text-body-2">
            <!-- {{ paramReceiverInfo.processMcReceiverInfo }} -->
            {{ genReceiveDesc(paramReceiverInfo.processMcReceiverInfo.at(-1)) }}
            <s-m-c-detail-button :process-mc-receiver-infos="paramReceiverInfo.processMcReceiverInfo" />

            <br>
            <!-- {{ paramReceiverInfo.processMcReceiverInfo }} -->
          <!-- TODO -->
          <!-- <v-list-item-icon
            v-if="!currCert.id"
            @click="removeStaff(index)"
          >
            <v-icon color="pink">
              {{ mdiClose }}
            </v-icon>
          </v-list-item-icon> -->
          </div>
        </div>
      </div>
      <br>
      <v-checkbox
        v-if="!currCert.id"
        v-model="hasMsg"
        :label="$t('eleave.Sick.MsgToDept')"
      />
      <v-textarea
        v-if="currCert.id || hasMsg"
        v-model="form.notifiedMsg"
        :label="$t('eleave.Sick.Msg')"
        outlined
      />

      <div v-if="!currCert.id">
        {{ toSupportDeptDesc }}
        <br>
        <v-btn
          class="primary"
          :loading="loading"
          @click="submit"
        >
          {{ $t('Text.Submit') }}<!--: {{ $chPtObjData('chinEntityName', bdrhStaff) }}-->
        </v-btn>
      </div>
    </v-card>

    <s-confirm-dialog
      v-model="isConfirmDialog"
      :message="$t('eleave.Sick.Confirm.NotifyListEmpty')"
      @confirm="confirmSubmit"
    />
  </v-container>
</template>

<script>

// import SSearchStaff from '@/components/SSearchStaff'
import SSearchStaffMuti from '@/components/SSearchStaffMuti.vue'
import { globalModule, sickLeaveModule, bdrhStaffModule } from '../../store/moduleName'
import sickLeaveVuex from '../../store/modules/leave/sickLeave'
import bdrhStaffVuex from '../../store/modules/hr/bdrhStaff'
import store from '../../store'
import { mapState } from 'vuex'
import { formatSSMDate, momentWithHyphen } from '../../utils/datetimeUtil'
import sickLeaveApi from '@/api/leave/sickLeave'
import { mdiArrowLeft, mdiClose, mdiFileDownloadOutline } from '@mdi/js'
import SClassPdf from '@/components/SClassPdf'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import { getStorage } from '@/utils/storageUtil'
import { LOCAL_STORAGE_KEY, MC_NOTIFY_STATUS, SEARCH_STAFF_RECORD_TYPE, DOC_FLOW_STATUS } from '@/constant/constant'
import { nvl, isFieldBlank } from '@/utils/stringUtil'
import { isArrayEmptyOrNull } from '@/utils/arrayUtil'
import SMCDetailButton from './components/SMCDetailButton.vue'
import SNoticeDialog from './components/SNoticeDialog'
import SConfirmDialog from '@/components/SConfirmDialog'

if (!store.state[sickLeaveModule]) store.registerModule(sickLeaveModule, sickLeaveVuex)
if (!store.state[bdrhStaffModule]) store.registerModule(bdrhStaffModule, bdrhStaffVuex)

export default {
  components: {
    // SSearchStaff,
    SConfirmDialog,
    SClassPdf,
    SMCDetailButton,
    SNoticeDialog,
    SSearchStaffMuti
  },
  props: {
  },
  data: function () {
    return {
      isConfirmDialog: false,
      loading: false,
      mdiClose: mdiClose,
      mdiArrowLeft: mdiArrowLeft,
      mdiFileDownloadOutline: mdiFileDownloadOutline,
      hasMsg: false,
      searchStaffCode: [],
      searchStaff: null,
      form: {
        claimCanbeFoundDay: null,
        claimCanbeFoundHour: null,
        claimCanbeFoundMinute: null,
        claimCanbeFoundLocation: null,
        keyNo: null,
        notifiedMsg: null,
        paramNotifyInfos: [],
        supportEntityId: null,
        staffList: []
      },
      toDafInfo: null,
      toSupportDeptDesc: null,
      ssmStatus: null
    }
  },
  computed: {
    ...mapState({
      bdrhStaff: state => state[bdrhStaffModule].info,
      currCert: state => state[sickLeaveModule].currCert
    }),
    hasSignedForm () {
      // return this.ssmStatus === SSM_STATUS.SIGNED
      return true
    },
    pdfPath () {
      console.log('pdfPath : ' + this.currCert.id)
      let path = ''
      if (this.currCert.id) {
        path = this.$config.apiDomain.ALI + '/ext/ps/mc/dlSignedPdfFromOSS?keyNo=' + this.currCert.keyNo + '&mcInfoId=' + this.currCert.id
      } else {
        path = this.$config.apiDomain.ALI + '/ext/ps/mc/dlSignedPdfFromSSM?keyNo=' + this.currCert.keyNo
      }
      let pdfInitParams = {
        url: path,
        httpHeaders: { Authorization: 'Bearer ' + getStorage(LOCAL_STORAGE_KEY.G2E_JWT_TOKEN) },
        withCredentials: true,
        CMapReaderFactory
      }
      return pdfInitParams
    }
  },
  mounted () {
    sickLeaveApi.getSupportEntity(resp => {
      if (!isFieldBlank(resp.data)) {
        this.form.supportEntityId = resp.data.supportEntityId
        this.toSupportDeptDesc = '(' + this.$t('MedicalCert.AlsoToSupportDept', [this.$chPtObjData('chinSupEntityName', resp.data)]) + ')'
      }
    })
    this.form.keyNo = this.currCert.keyNo
    if (this.currCert.id) {
      /*
      sickLeaveApi.checkSSMStatusAndDLSigned(resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.ssmStatus = resp.data
        }
      }, this.currCert.keyNo, this.currCert.id)
      */
      sickLeaveApi.findSubmitToDafMCInfoByKeyNo(this.currCert.keyNo, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.toDafInfo = resp.data
          // this.form.paramNotifyInfos = this.toDafInfo.notifyStaffInfoVos
          this.form.notifiedMsg = this.toDafInfo.notifiedMsg
          this.form.claimCanbeFoundDay = this.toDafInfo.claimCanbeFoundDay
          this.form.claimCanbeFoundHour = this.toDafInfo.claimCanbeFoundHour
          this.form.claimCanbeFoundMinute = this.toDafInfo.claimCanbeFoundMinute
          this.form.claimCanbeFoundLocation = this.toDafInfo.claimCanbeFoundLocation

          if (this.toDafInfo.dfInflowId) {
            sickLeaveApi.findMcReceiverInfo(this.currCert.keyNo, this.toDafInfo.dfInflowId, resp => {
              if (resp.status === 201 || resp.status === 200) {
                this.form.paramNotifyInfos = resp.data
                // console.log('this.currCert.keyNo' + this.currCert.keyNo + ', this.toDafInfo.dfInflowId : ' + this.toDafInfo.dfInflowId + ', ' + this.form.paramNotifyInfos.length)
              }
            })
          }
        }
      })
    } else {
      sickLeaveApi.findLastNotifyInfo(resp => {
        if (resp.status === 201 || resp.status === 200) {
          if (!isArrayEmptyOrNull(resp.data)) {
            // console.log('resp.data : ' + resp.data)
            let staffList = resp.data
            // console.log('staffList : ' + staffList.length)
            // let staff = resp.data[0]
            // console.log('staff : ' + staff.notifiedEuid + ' ' + staff.notifiedGid)
            this.searchStaffCode = []
            for (let i = 0; i < staffList.length; i++) {
              let staff = staffList[i]
              if (staff.notifiedEuid) {
                this.searchStaffCode.push(staff.notifiedEuid)
              } else if (staff.notifiedGid) {
                this.searchStaffCode.push(staff.notifiedGid + '')
              }
            }
          }
          /*
          resp.data.forEach(e => {
            let tStaff = {
              notifiedEuid: e.notifiedEuid,
              notifiedStaffCode: e.notifiedStaffCode,
              chinNotifiedStaffName: e.chinNotifiedStaffName,
              portNotifiedStaffName: e.portNotifiedStaffName,
              notifiedGid: e.notifiedGid,
              chinNotifiedGroupName: e.chinNotifiedGroupName,
              portNotifiedGroupName: e.portNotifiedGroupName
            }
            this.form.paramNotifyInfos.push(tStaff)
          })
          */
        }
      })
    }
  },
  methods: {
    downloadSignedForm: function () {
      sickLeaveApi.downloadSignedPdfFromOSS(resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'sickForm.pdf')
          link.click()
          window.URL.revokeObjectURL(url)
        }
      }, this.currCert.keyNo, this.currCert.id)
    },
    downloadSignedPdfFromOSS: function () {
      // console.log('currCert : ' + JSON.stringify(this.currCert))
      sickLeaveApi.downloadSignedPdfFromOSS(resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'sickForm.pdf')
          link.click()
          window.URL.revokeObjectURL(url)
        }
      }, this.currCert.keyNo, this.currCert.id)
    },
    downloadSignedPdfFromSSM: function () {
      sickLeaveApi.downloadSignedPdfFromSSM(resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'sickForm.pdf')
          link.click()
          window.URL.revokeObjectURL(url)
        }
      }, this.currCert.keyNo)
    },
    // genNoticeDesc: function (notice) {
    //   if (notice.notifiedGid) {
    //     return nvl(notice.chinNotifiedGroupName, '') + (notice.chinNotifiedGroupName ? ' ' : '') + nvl(notice.portNotifiedGroupName, '')
    //   } else {
    //     return notice.notifiedEuid + ' ' + nvl(notice.chinNotifiedStaffName, '') + (notice.chinNotifiedStaffName ? ' ' : '') + nvl(notice.portNotifiedStaffName, '')
    //   }
    // },
    genReceiveDesc: function (receive) {
      if (receive.statusCode === DOC_FLOW_STATUS.CANCEL) {
        return '(' + this.$t('Text.Cancel') + ')'
      } else if (receive.statusCode === DOC_FLOW_STATUS.CLOSED) {
        return '(' + this.$t('DocFlow.StatusCode.CLOSED') + ')'
      } else if (receive.receiverGid) {
        return this.$t('TaskList.Waiting') + ' ' + nvl(receive.chinNotifiedGroupName, '') + (receive.chinNotifiedGroupName ? ' ' : '') + nvl(receive.portNotifiedGroupName, '')
      } else {
        return this.$t('TaskList.Waiting') + ' ' + nvl(receive.chinNotifiedStaffName, '') + (receive.chinNotifiedStaffName ? ' ' : '') + nvl(receive.portNotifiedStaffName, '')
      }
    },
    addStaffToNotice: function () {
      if (this.searchStaffCode !== null) {
        let tStaff = {}
        if (this.searchStaff.recordType === SEARCH_STAFF_RECORD_TYPE.GROUP) {
          tStaff.notifiedGid = this.searchStaff.definedGroupId
          tStaff.chinNotifiedGroupName = this.searchStaff.definedGroupChinName
          tStaff.portNotifiedGroupName = this.searchStaff.definedGroupPortName
        } else {
          tStaff.notifiedEuid = this.searchStaff.euid
          tStaff.notifiedStaffCode = this.searchStaff.staffCode
          tStaff.chinNotifiedStaffName = this.searchStaff.chinName
          tStaff.portNotifiedStaffName = this.searchStaff.portName
        }
        this.form.paramNotifyInfos = [tStaff]
      }
    },
    addStaffListToNotice: function () {
      this.form.paramNotifyInfos = []
      for (let i = 0; i < this.form.staffList.length; i++) {
        let staff = this.form.staffList[i]
        let tStaff = {}
        if (staff.recordType === SEARCH_STAFF_RECORD_TYPE.GROUP) {
          tStaff.notifiedGid = staff.definedGroupId
          tStaff.chinNotifiedGroupName = staff.definedGroupChinName
          tStaff.portNotifiedGroupName = staff.definedGroupPortName
        } else {
          tStaff.notifiedEuid = staff.euid
          tStaff.notifiedStaffCode = staff.staffCode
          tStaff.chinNotifiedStaffName = staff.chinName
          tStaff.portNotifiedStaffName = staff.portName
        }
        this.form.paramNotifyInfos.push(tStaff)
      }
    },
    formatDate: function (dateStr) {
      if (!this.currCert.id) {
        return formatSSMDate(dateStr)
      } else {
        return momentWithHyphen(dateStr).format('YYYY-MM-DD')
      }
    },
    removeStaff: function (index) {
      this.form.paramNotifyInfos.splice(index, 1)
    },
    confirmSubmit: function () {
      // console.log('submit : ' + JSON.stringify(this.staffList))
      // console.log('submit : ' + JSON.stringify(this.form.staffList))
      this.loading = true
      // this.addStaffToNotice()
      this.addStaffListToNotice()
      if (this.currCert.isNoNeedToStayAtHome) {
        if (isFieldBlank(this.form.claimCanbeFoundDay) ||
            isFieldBlank(this.form.claimCanbeFoundHour) ||
            isFieldBlank(this.form.claimCanbeFoundMinute) ||
            isFieldBlank(this.form.claimCanbeFoundLocation)
        ) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsWrite', [this.$t('eleave.Statement')]))
          this.loading = false
          return false
        }
      }
      // if (isArrayEmptyOrNull(this.form.paramNotifyInfos)) {
      //   this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsWrite', [this.$t('eleave.Sick.noticeStaff')]))
      //   this.loading = false
      //   return false
      // }
      // console.log('staffList : ' + this.form.staffList)
      /**/
      sickLeaveApi.submitToDaf(this.form, resp => {
        this.loading = false
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          this.$router.push({ name: 'sickLeaveList' })
        }
      })
    },
    submit: function () {
      if (isArrayEmptyOrNull(this.form.staffList)) {
        this.isConfirmDialog = true
      } else {
        this.confirmSubmit()
      }
    },
    notifyStatus: function (notify) {
      if (notify.statusCode === MC_NOTIFY_STATUS.WAIT) {
        return ''
      } else if (notify.statusCode === MC_NOTIFY_STATUS.CANCEL) {
        return '(' + this.$t('Text.Cancel.ed') + ', ' + momentWithHyphen(notify.viewedTime).format('YYYY-MM-DD HH:mm:ss') + ')'
      } else if (notify.statusCode === MC_NOTIFY_STATUS.READ) {
        return '(' + this.$t('MedicalCert.Noted') + ', ' + momentWithHyphen(notify.viewedTime).format('YYYY-MM-DD HH:mm:ss') + ')'
      } else if (notify.statusCode === MC_NOTIFY_STATUS.REDIRECTED) {
        return '(' + this.$t('MedicalCert.Redirected') + ', ' + momentWithHyphen(notify.viewedTime).format('YYYY-MM-DD HH:mm:ss') + ')'
      }
    },
    notifyClass: function (notify) {
      if (notify.statusCode === MC_NOTIFY_STATUS.CANCEL) {
        return 'error--text'
      } else {
        return 'success--text'
      }
    }
  }
}
</script>
